import { render, staticRenderFns } from "./TestimonialCard.vue?vue&type=template&id=50bf157a&scoped=true&"
import script from "./TestimonialCard.vue?vue&type=script&lang=ts&"
export * from "./TestimonialCard.vue?vue&type=script&lang=ts&"
import style0 from "./TestimonialCard.vue?vue&type=style&index=0&id=50bf157a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bf157a",
  null
  
)

export default component.exports